<template>
  <span></span>
</template>

<script>
  import {mapGetters, mapState} from "vuex";
import calendarCheck from "@/mixins/tags/calendarCheck";
import apiClientCreator from "@/helpers/api/request";

export default {
  name: "CalendarRangesController",
  props: {
    filterNewDate: {
      type: Boolean,
      required: true
    },
    activeTags: {
      type: Array,
      required: true
    }
  },
  mixins: [calendarCheck],
  computed: {
    ...mapState("user", ["auth"]),
    ...mapGetters("user", ["isLogged"]),
    ...mapState("clients", [
      "generalQueryObject",
      "chartsMainView",
      "chartsViewBlocks",
      "multiSelectChartData",
      "selectedTopTag",
      "selectedTag",
      "shortCutsToBlocks",
      "reqSpecialDates"
    ])
  },
  data() {
    return {};
  },
  watch: {
    selectedTopTag: function() {
      this.getDatesForParams(this.selectedTopTag);
    },
    reqSpecialDates() {
      if (this.reqSpecialDates) {
        this.getDatesForParams(
          this.reqSpecialDates.mainSector,
          this.reqSpecialDates.id
        );
      }
    }
  },

  methods: {
    async getDatesForParams(tag, id = false) {
      if (!tag || tag === "") {
        return;
      }
      let queryObject = this.generalQueryObject;
      if (id) {
        queryObject = { ...queryObject, spc_id: id };
      }
      await apiClientCreator(`client/stats/calendar/get_dates_for_tag/${tag}`)
        .get("", { params: queryObject })
        .then(res => {
          this.setCalendarDates(res.data);
        })
        .catch(err => {});
    },

    setCalendarDates(data) {
      if (data.dates[0]) {
        let block = this.shortCutsToBlocks.find(tab => {
          return tab.short === data.cal;
        });

        this.$store.commit("clients/setCalendarDates", {
          calendar: block.calendar,
          dates: {
            start: data.dates[0],
            end: data.dates[1]
          }
        });
      }
    },

    setCalendarOldDates(calendar) {
      let block = this.shortCutsToBlocks.find(tab => {
        return tab.short === calendar;
      });
      if (block) {
        this.$store.commit("clients/setCalendarDates", {
          calendar: block.calendar,
          dates: false
        });
      }
    }
  }
};
</script>

<style scoped></style>
